import { render, staticRenderFns } from "./seriesgoods_editor.vue?vue&type=template&id=0ec3c80f"
import script from "./seriesgoods_editor.vue?vue&type=script&lang=js"
export * from "./seriesgoods_editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports